import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-46" data-mp="a5ofw4uob68">
      <div className="mx-auto max-w-5xl" data-id="element-47" data-mp="9vy27fw8200">
        <div className="mx-auto max-w-3xl text-center" data-id="element-48" data-mp="58z702yzusd9">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-red-500" data-id="element-49" data-mp="57ebaa0y13dt">
            The Hospitality English Ready™ Difference
          </span>
          <h2 className="mt-5 text-[2rem] font-black leading-[1.08] tracking-tight text-stone-900 sm:text-5xl" data-id="element-50" data-mp="3rgp8m1wktdh7">
            From Textbook English to{' '}
            <span className="italic text-red-500" data-id="element-51" data-mp="3dj0o4v6f88co">Guest-Ready Staff.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-stone-600 sm:text-base" data-id="element-52" data-mp="3ihv65uwkdsvq">
            Give your lessons real hotel situations, your students the language
            guests expect, and yourself the time to enjoy teaching again.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-stone-200 bg-white sm:grid-cols-3" data-id="element-53" data-mp="1j9m6ujrd90br">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-stone-200 sm:border-l sm:border-t-0' : ''}`} data-id="element-54" data-mp="1szxae57517i4" data-mpi={index}>
              <dt className="sr-only" data-id="element-55" data-mp="1o488hv7nbein">{stat.label}</dt>
              <dd data-id="element-56" data-mp="10d2rvdtvsi7a">
                <span className="block text-3xl font-black text-red-500" data-id="element-57" data-mp="10ckzisacao4n">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-stone-500" data-id="element-58" data-mp="1aah8bdft16zl">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-xl" data-id="element-59" data-mp="2lpdzotzgo8a4">
          <div className="grid md:grid-cols-2" data-id="element-60" data-mp="2lrh087y8pjt3">
            <div className="relative bg-stone-100 p-8 sm:p-10" data-id="element-61" data-mp="2gphwuy2i2mw5">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-stone-400" data-id="element-62" data-mp="2orirfqarrks4">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-63" data-mp="2srj3j4aebjw0" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500" data-id="element-64" data-mp="2xsysv8jlwck7">
                The cost of improvising
              </span>
              <h3 className="mt-3 text-2xl font-bold tracking-wide text-stone-900" data-id="element-65" data-mp="2539ruv6wccil">
                BEFORE
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-500" data-id="element-66" data-mp="2a1l0j2lgggz8">
                What building hotel lessons from scratch quietly takes from
                your week.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-67" data-mp="2jsfpieq35uod">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-full bg-white/70 px-4 py-3 text-sm text-stone-600" data-id="element-68" data-mp="1md1pwgexns3z">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-stone-400" aria-hidden="true" data-id="element-69" data-mp="1rati7bjhpg8p" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-70" data-mp="1esptiqc86b4a">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-red-500 text-white" data-id="element-71" data-mp="1er6d8zqkk02i">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-72" data-mp="14vl5sm2qe7ld" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-red-500" data-id="element-73" data-mp="10tzvn8hl07ev">
                The Hospitality English Ready™ system
              </span>
              <h3 className="mt-3 text-2xl font-bold tracking-wide text-stone-900" data-id="element-74" data-mp="w0wx0lxy67rt">
                WITH THE TOOLKIT
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-500" data-id="element-75" data-mp="m5d488eojp7a">
                Walk into every lesson with real guest scenarios ready to go.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-76" data-mp="d45isqx9iium">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-stone-900" data-id="element-77" data-mp="d603q58jaayp">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-78" data-mp="16u5y2ohoo4k2" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-stone-100 bg-stone-50 px-6 py-4 text-center text-xs text-stone-500" data-id="element-79" data-mp="x3b9hdgyssvg">
            A complete system to plan less and prepare staff guests remember.
          </p>
        </div>
      </div>
    </section>;
}